var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.modalOpen,"max-width":"600px"},on:{"input":_vm.hideModal}},[_c(_vm.modalComponent,{tag:"component",attrs:{"programId":_vm.programId},on:{"close":_vm.hideModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }